import successModal from "../components/ConfirmationModal";
import { confirmTick } from "../assets";
import { experienceExamsUrl } from "./experienceApp";

// The success modal dismisses itself after 2s — hand the tab back just before that,
// so the student reads the confirmation and then lands on My Exams.
const HANDBACK_DELAY_MS = 1800;

/**
 * Shared ending for a submitted attempt (the Submit Test button and the header's End
 * Test button both come through here).
 *
 * The candidate is handed back to Xperience → My Exams, which is where they started
 * and where the result appears. `leavePortal` still runs first: it takes them out of
 * the exam UI immediately, so if the hand-back is unavailable (no Xperience app URL
 * configured for this build) they are left somewhere sensible instead of staring at
 * the paper they just submitted.
 */
export function finishExam(text: string, leavePortal: () => void): void {
  leavePortal();
  successModal.show({ image: confirmTick, text });

  const target = experienceExamsUrl();
  if (!target) return;
  setTimeout(() => window.location.assign(target), HANDBACK_DELAY_MS);
}
